<script>
import drushim_lodash from 'lodash'
import JobItem from '@/components/Jobs_List/Jobs_On_Drushim/Job_Item/JobItem'
import Spinner from '@/components/Spinner/Spinner'
import { mapState, mapGetters } from 'vuex'
import SeoOptimization from '@/components/mixins/SeoOptimization'

export default {
  components: {
    JobItem,
    Spinner,
  },
  mixins: [SeoOptimization],

  data() {
    return {
      API_URL: '',
      items: undefined,
      sortedItems: null,
      showComponent: true,
      emptyMsg: false,
      itemsCount: '',
      formBasketModel: false,
      jobBasketModel: [],
      jobsToSend: [],
      selectAll: false,
      selectFew: false,
      isJobApplied: false,
      updated: false,
      generalDFP: {
        dfpID: '3177829/personalarea_baner_desktop',
        dfpSize: [925, 100],
        id: '1588421797276-0',
      },
      mobileDFP: {
        dfpID: '3177829/search_results_mob',
        dfpSize: [320, 50],
        id: '1585638687340-0',
      },
    }
  },

  watch: {
    JobBasketSize() {
      this.updated = true
      this.fetchFavJobs()
    },

    jobBasketModel(newVal) {
      /**
       * Clean null Objects
       */
      const _temp = this.jobBasketModel.filter((item, i) => {
        return !drushim_lodash.isNil(item)
      })
      this.jobsToSend = [..._temp]
    },

    selectAll(newVal) {
      this.jobsToSend = []
      this.jobBasketModel = []

      if (newVal) {
        this.jobBasketModel = [...this.items]
      }
    },
  },
  head() {
    return {
      title: this.seodata.pageTitle,
      meta: this.seodata.metaData,
    }
  },
  mounted() {
    /**
     * will update model if remove from favorites
     */
    this.$bus.$on('updateSendList', this.updateFromBasket)
    this.$nuxt.$on('jobApplied', this.jobApplied)
    this.$nuxt.$emit('hideEditForm')
    this.fetchFavJobs()
  },
  computed: {
    dfpToShow() {
      return this.$vuetify.breakpoint.smAndUp ? this.generalDFP : this.mobileDFP
    },
    ssa() {
      return drushim_lodash.get(this.$ssa, 'vm', {})
    },
    ...mapState({ jobsBasket: (state) => state.authUser.jobsBasket }),
    ...mapGetters([
      'JobBasket',
      'NoJobBasket',
      'checkIfJobIsLiked',
      'isLogged',
    ]),

    JobBasketSize() {
      if (this.isLogged) {
        return this.JobBasket?.length
      }

      return this.jobsBasket.size || 0
    },

    isMobile() {
      return this.$vuetify.breakpoint.xsOnly
    },
  },

  beforeDestroy() {
    this.$bus.$off('updateSendList')
    this.$nuxt.$off('jobApplied')
  },

  methods: {
    sendSSA(eventName) {
      this.ssa.logBulk('LogSSA', {
        eventName: eventName,
        jobcodes: this.getJobsCodes(),
      })
    },
    getJobsCodes() {
      let jobsCodes = drushim_lodash.map(this.jobsToSend, this.setQuery)

      return jobsCodes
    },
    setQuery(n) {
      return n.Code
    },
    /**
     * will update list if Single job applied by Execute  jobApplied Func.
     * @param {Boolean} val  is job Applied , emit from job item
     * @param {Number} JobCode  for detect on list
     *
     */

    jobApplied(val, code) {
      if (val) {
        this.updateFromBasket(code)
      }
    },
    sendCV() {
      this.$nuxt.$emit('jobsToSendCv')
      this.sendSSA('ListingOAFClickedBulk')
    },
    updateFromBasket(val) {
      /***
       * will unchek job item checkbox if item remove from basket to prevent sending uncheck job
       */

      const newitems = drushim_lodash.filter(this.items, (obj) => {
        return obj.Code != val
      })
      const newbasket = drushim_lodash.filter(this.jobBasketModel, (obj) => {
        return obj.Code != val
      })

      this.items = [...newitems]
      this.jobBasketModel = [...newbasket]
    },
    inputFilter(val) {
      /**
       *Currently not in use
       */

      let results = []
      results = drushim_lodash.filter(this.items, (obj) => {
        const description = drushim_lodash.isNil(obj.JobContent.Description)
          ? ''
          : obj.JobContent.Description

        const companyDisplayName = drushim_lodash.isNil(obj.Company.CompanyDisplayName)
          ? ''
          : obj.Company.CompanyDisplayName
        const fullName = drushim_lodash.isNil(obj.JobContent.Name) ? '' : obj.JobContent.Name
        const requirements = drushim_lodash.isNil(obj.JobContent.Requirements)
          ? ''
          : obj.JobContent.Requirements

        return (
          description.indexOf(val) !== -1 ||
          fullName.indexOf(val) !== -1 ||
          companyDisplayName.indexOf(val) !== -1 ||
          requirements.indexOf(val) !== -1
        )
      })
      this.sortedItems = [...results]
    },

    async fetchFavJobs() {
      let { query } = !this.updated ? this.$route : ''
      this.showComponent = true
       await this.$axios
        .get(this.API_URL, {
          params: query,
          withCredentials: true,
        })
        .then((response) => {
          this.showComponent = false
          if (response.data.IsError) {
            throw new Error('שגיאת מערכת ')
          }

          if (response.data.IsRedirect) {
            let redirectUrl = response.data.RedirectTo
            window.location = redirectUrl
            return;
          }

          const { ResultList } = response.data
          this.items = [...ResultList]
          this.itemsCount = response.data.Count
          this.emptyMsg = this.items?.length === 0
          this.jobBasketModel = []
          this.seodata = {
            metaData: response.data.SEO.MetaDataItems,
            pageTitle: response.data.SEO.title,
          }

          if (!this.isLogged && this.itemsCount > 0) {
            this.$store.dispatch(
              'addJobsToFavorites',
              ResultList.map((j) => j.Code)
            )
          }
        })
        .catch(function (error) {
          console.log(error)
        })

      //refresh job basket when coming from mail
      if (this.isLogged && query && Object.keys(query)?.length > 0) {
        await this.$auth.fetchUser()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.job-item {
  position: relative;
  border-right: 9px solid #f2f0ef;

}

.job-item.detailsIsOpen {
  background-color: #f6f7f9;
}

.job-item.preferred {
  border-right: 9px solid $primary;
}

.job-item.preferred.job-submitted {
  border-right: 9px solid $lightGreen;
}

.job-item.job-submitted {
  border-right: 9px solid $lightGreen;
}

.job-item.job-submitted.detailsIsOpen:after {
  display: none;
}

.job-select-box {
  box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.46);
}

#selectAllcheck .indeterminate .v-icon {
  border: 2px solid red;
}

@media screen and (max-width: 600px) {
  #send-cv-to-all {
    position: fixed;
    bottom: 0;
    padding: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 100%;
    height: 65px;
    font-size: 24px;
    border-top: 2px solid #fff !important;
    background-color: $primary;
    z-index: 20;
    padding: 14px 0;
    display: flex;
    justify-content: center;
  }

  #send-cv-to-all button {
    width: 100%;
  }
}
</style>
